import React from "react";
import { withRouter, Link, NavLink } from "react-router-dom";
import * as Icon from "react-feather";
import "./Navigation.css";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Row,
  Col,
  Form,
  FormControl,
  Button,
  Image,
} from "react-bootstrap";

import ColorSwitch from "../Common/ColorSwitch";
import UserAvatar from "../Common/UserAvatar";
import { useSignOut, useAuthUser } from "react-auth-kit";

// Default dark side menu
import SideMenuDark from "./SideMenu/SideMenuDark";
// If want to active light sidebar then please uncomment below & comment above component
import SideMenuLight from "./SideMenu/SideMenuLight";

// Logo image path
import Logo from "../../assets/img/kinexion-logo.png";
import SmallLogo from "../../assets/img/kinexion-small-logo.png";

// Profile & user image path
import profile from "../../assets/img/profile.jpeg";
import user1 from "../../assets/img/user/user1.jpg";
import user2 from "../../assets/img/user/user2.jpg";
import user3 from "../../assets/img/user/user3.jpg";
import SwitchToRtl from "../Common/SwitchToRtl";

const Navigation = ({ history, onClick }) => {
  const [sideMenu, setSideMenu] = React.useState(false);
  const [term, setTerm] = React.useState("");
  const [menuColor, setMenuColor] = React.useState(false);

  const signOut = useSignOut();
  const authUser = useAuthUser();

  const _toggleClass = () => {
    setSideMenu(!sideMenu);
    onClick(sideMenu);
  };

  const _handleSubmit = (event) => {
    event.preventDefault();
    if (term) {
      history.push("/search/");
    }
  };

  const onSideMenuHandler = (activeColor) => {
    setMenuColor(activeColor);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    signOut();
    history.push('/login');
  };

  const userEmail = authUser()?.email || 'User';
  const userFirstName = authUser()?.first_name || '';
  const userLastName = authUser()?.last_name || '';
  const isCompanyAdmin = authUser()?.is_company_admin;
  const userName = userFirstName && userLastName
    ? `${userFirstName} ${userLastName}`
    : (userEmail.split('@')[0] || 'User');
return (
  <div className="page-wrapper">
    <Navbar fixed="top" className={`top-menu ${sideMenu ? "top-menu-collapsed" : ""}`}>
      <Link
        to="/"
        className={`navbar-brand ${
          sideMenu ? "navbar-logo" : ""
        }`}
      >
        {/* Large logo */}
        <Image src={Logo} alt="Logo" className="large-logo" />
        {/* Small logo */}
        <Image src={SmallLogo} alt="Small Logo" className="small-logo" />
      </Link>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />

      {/* Burger menu */}
      <div
        className={`burger-menu ${
          sideMenu ? "toggle-menu" : ""
        }`}
        onClick={_toggleClass}
      >
        <span className="top-bar"></span>
        <span className="middle-bar"></span>
        <span className="bottom-bar"></span>
      </div>
      {/* End Burger menu */}

          <Navbar.Collapse id="basic-navbar-nav">
            {/* <Nav className="left-nav d-none d-md-block">
              <NavDropdown
                title={
                  <div className="mega-menu-btn">
                    Mega Menu
                    <Icon.ChevronDown className="icon" />
                  </div>
                }
                id="basic-nav-dropdown"
                className="mega-menu"
              >
                <Container>
                  <Row>
                    <Col md={6} lg={3}>
                      <h5 className="title">Features</h5>
                      <NavLink
                        to="/ui-components/alerts"
                        className="dropdown-item"
                      >
                        Alerts
                      </NavLink>
                      <NavLink
                        to="/ui-components/badges"
                        className="dropdown-item"
                      >
                        Badges
                      </NavLink>
                      <NavLink
                        to="/ui-components/buttons"
                        className="dropdown-item"
                      >
                        Buttons
                      </NavLink>
                    </Col>

                    <Col md={6} lg={3}>
                      <h5 className="title">Features</h5>
                      <NavLink
                        to="/ui-components/cards"
                        className="dropdown-item"
                      >
                        Cards
                      </NavLink>
                      <NavLink
                        to="/ui-components/dropdowns"
                        className="dropdown-item"
                      >
                        Dropdowns
                      </NavLink>
                      <NavLink
                        to="/ui-components/forms"
                        className="dropdown-item"
                      >
                        Forms
                      </NavLink>
                    </Col>

                    <Col md={6} lg={3}>
                      <h5 className="title">Features</h5>
                      <NavLink
                        to="/ui-components/list-groups"
                        className="dropdown-item"
                      >
                        List Groups
                      </NavLink>
                      <NavLink
                        to="/ui-components/modals"
                        className="dropdown-item"
                      >
                        Modals
                      </NavLink>
                      <NavLink
                        to="/ui-components/progress-bars"
                        className="dropdown-item"
                      >
                        Progress Bars
                      </NavLink>
                    </Col>

                    <Col md={6} lg={3}>
                      <h5 className="title">Features</h5>
                      <NavLink
                        to="/ui-components/tables"
                        className="dropdown-item"
                      >
                        Tables
                      </NavLink>
                      <NavLink
                        to="/ui-components/tabs"
                        className="dropdown-item"
                      >
                        Tabs
                      </NavLink>
                      <NavLink
                        to="/signup"
                        className="dropdown-item"
                        target="_blank"
                      >
                        Signup
                      </NavLink>
                    </Col>
                  </Row>
                </Container>
              </NavDropdown>
            </Nav> */}

            {/* <Form
              className="nav-search-form d-none d-sm-block"
              onSubmit={this._handleSubmit}
              action="/search/"
            >
              <FormControl
                type="text"
                value={this.state.term}
                onChange={(e) => this.setState({ term: e.target.value })}
                placeholder="Search..."
              />

              <Button className="search-success" type="submit">
                <Icon.Search className="icon" />
              </Button>
            </Form> */}

            <Nav className="ms-auto right-nav">
              <NavDropdown
                title={
                  <div className="count-info">
                    <Icon.Mail className="icon" />
                    <span className="ci-number theme-bg">
                      <span className="ripple theme-bg"></span>
                      <span className="ripple theme-bg"></span>
                      <span className="ripple theme-bg"></span>
                    </span>
                  </div>
                }
                id="basic-nav-dropdown"
                className="message-box"
              >
                <NavLink to="/inbox/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user1} alt="User Image" roundedCircle />
                      <span className="profile-status online"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Eduardo Cervantes</h5>
                      <span className="mail-desc">
                        Just sent a new comment!
                      </span>
                    </span>
                    <span className="time">0 seconds ago</span>
                  </div>
                </NavLink>

                <NavLink to="/inbox/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user2} alt="User Image" roundedCircle />
                      <span className="profile-status ofline"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Marco Gomez</h5>
                      <span className="mail-desc">
                        Just sent a new comment!
                      </span>
                    </span>
                    <span className="time">5 minutes ago</span>
                  </div>
                </NavLink>

                <NavLink to="/inbox/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user3} alt="User Image" roundedCircle />
                      <span className="profile-status away"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Mitch Petty</h5>
                      <span className="mail-desc">
                        Just sent a new comment!
                      </span>
                    </span>
                    <span className="time">9:00 AM</span>
                  </div>
                </NavLink>

                <Link to="/inbox/" className="dropdown-item">
                  See all e-mails
                  <Icon.ChevronRight className="icon" />
                </Link>
              </NavDropdown>

              <NavDropdown
                title={
                  <div className="count-info">
                    <Icon.Bell className="icon" />
                    <span className="ci-number">
                      <span className="ripple"></span>
                      <span className="ripple"></span>
                      <span className="ripple"></span>
                    </span>
                  </div>
                }
                id="basic-nav-dropdown"
                className="message-box"
              >
                <NavLink to="/notifications/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user1} alt="User Image" roundedCircle />
                      <span className="profile-status online"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Eduardo Cervantes</h5>
                      <span className="mail-desc">
                        Just sent a new comment!
                      </span>
                    </span>
                    <span className="time">0 seconds ago</span>
                  </div>
                </NavLink>

                <NavLink to="/notifications/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user2} alt="User Image" roundedCircle />
                      <span className="profile-status ofline"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Marco Gomez</h5>
                      <span className="mail-desc">
                        Just sent a new comment!
                      </span>
                    </span>
                    <span className="time">5 minutes ago</span>
                  </div>
                </NavLink>

                <NavLink to="/notifications/" className="dropdown-item">
                  <div className="message-item">
                    <span className="user-pic">
                      <Image src={user3} alt="User Image" roundedCircle />
                      <span className="profile-status away"></span>
                    </span>

                    <span className="chat-content">
                      <h5 className="message-title">Mitch Petty</h5>
                      <span className="mail-desc">
                        New order received! <span className="amount">$250</span>
                      </span>
                    </span>
                    <span className="time">9:00 AM - 02-02-2019</span>
                  </div>
                </NavLink>

                <Link to="/notifications/" className="dropdown-item">
                  Check all notifications
                  <Icon.ChevronRight className="icon" />
                </Link>
              </NavDropdown>

              <NavDropdown
                title={
                  <div className="menu-profile">
                    <span className="name">{userName}</span>
                    <UserAvatar
                      name={userName}
                      imageUrl={null}
                      size="small"
                    />
                  </div>
                }
                id="basic-nav-dropdown"
                className="profile-nav-item"
              >
                <NavLink to="/profile/" className="dropdown-item">
                  <Icon.User className="icon" />
                  Perfil
                </NavLink>
                <NavLink to="/inbox/" className="dropdown-item">
                  <Icon.Inbox className="icon" />
                  Buzon
                </NavLink>
                <NavLink to="/chat/" className="dropdown-item">
                  <Icon.HelpCircle className="icon" />
                  Soporte
                </NavLink>
                <NavLink to="/profile-settings/" className="dropdown-item">
                  <Icon.Settings className="icon" />
                  Configuracion
                </NavLink>
                {isCompanyAdmin && (
                  <NavLink to="/company-settings/" className="dropdown-item">
                    <Icon.Briefcase className="icon" />
                    Config. Empresa
                  </NavLink>
                )}
                <NavLink to="/manual/" className="dropdown-item">
                  <Icon.BookOpen className="icon" />
                  Manual
                </NavLink>
                <NavLink to="/cambiar-contrasena/" className="dropdown-item">
                  <Icon.Lock className="icon" />
                  Cambiar Contrasena
                </NavLink>
                <a href="#" onClick={handleLogout} className="dropdown-item">
                  <Icon.LogOut className="icon" />
                  Cerrar Sesion
                </a>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

      {/* Side Menu File Path: src/components/Navigation/SideMenu/SideMenu.js */}
      {!menuColor ? (
        <SideMenuDark sideMenu={sideMenu} />
      ) : (
        <SideMenuLight sideMenu={sideMenu} />
      )}

      {/* Side Menu File Path: src/components/Common/ColorSwitch.js */}
      {/* <ColorSwitch onClick={onSideMenuHandler} /> */}

      {/* SwitchToRtl */}
      {/* <SwitchToRtl /> */}
    </div>
  );
};

export default withRouter(Navigation);
